import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgDropFilesDirective } from 'src/app/directives/ng-drop-files.directive';
import { Papa } from 'ngx-papaparse';

export class CMProceced {
  proceced: any[];
  excluded: any[];
}

@Component({
  selector: 'app-carga-masiva',
  templateUrl: './carga-masiva.component.html',
  styleUrls: ['./carga-masiva.component.css'],
  providers: [NgDropFilesDirective]
})
export class CargaMasivaComponent implements OnInit {
  filesType: string[] = ['zip', 'rar', 'pdf', 'jpg', 'png', 'jpeg', 'xlsx', 'xls', 'docx', 'doc', 'txt', 'csv'];
  data: any[] = [];
  files: File[] = [];
  multiple = false;
  mostrar = false;
  last: number;
  estaSobreElemento = false;
  constructor(
    public activeModal: NgbActiveModal,
    public dropFile: NgDropFilesDirective,
    private papa: Papa
  ) { }

  ngOnInit() { }

  accept = () => `.${this.filesType.join(', .')}`;

  changeFiles(files: FileList) {
    if (this.files.length >= 1 && !this.multiple) { this.files.splice(0, 1); }
    this.files = this.dropFile.changeFiles(files, this.files, this.filesType, this.multiple);
    this.mostrar = false;
  }

  eliminaImg = (ind) => this.files.splice(ind, 1);

  checkType(type: string) {
    const image = ['jpg', 'png', 'jpeg'];
    let typeFile = this.filesType.find(x => type.includes(x)) || 'file';
    typeFile = (image.includes(type.trim().toLocaleLowerCase().substr(-4).replace('.', '')) || type.includes('image')) ?
      typeFile = 'image' : typeFile;

    return (typeFile.includes('image') || typeFile.includes('pdf')) ? `-${typeFile}-o` :
      (typeFile.includes('zip') || typeFile.includes('rar')) ? '-zip-o' : (typeFile.includes('docx') || type.includes('word')) ? '-word-o' :
        ((typeFile.includes('xlsx') || type.includes('sheet')) || (typeFile.includes('xls') || type.includes('excel'))) ? '-excel-o' : '';
  }

  cargar() {
    if (this.files.length === 0) { this.mostrar = true; }
    const list = [];
    const dat = JSON.parse(JSON.stringify(this.data));
    const excluded = [];
    this.files.forEach((x, key, arr) => this.papa.parse(x, {
      header: true,
      delimiter: '',
      complete: (result) => {
        this.separateObject(result, dat);
        (result.data as any[]).forEach((b, k, a) => {
          if (!dat.find(s => JSON.stringify(s).toLocaleLowerCase() === JSON.stringify(b).toLocaleLowerCase())) {
            list.push(b);
          } else {
            excluded.push(b);
          }
          if (Object.is(a.length - 1, k)) {
            if (Object.is(arr.length - 1, key)) {
              const proceced = this.uniq(list);
              let last = ((this.data.length > 0) ? parseInt(this.data[this.data.length - 1].id, 0) : 0) + 1;
              proceced.forEach(p => Object.assign(p, { status: true, id: last++ }));
              this.notUniq(list).forEach(m => excluded.push(m));
              this.activeModal.close({ proceced, excluded } as CMProceced);
            }
          }
        });
      }
    }));
  }

  uniq = (list: any[]) => list.filter((thing, index) => (index === list.findIndex(obj => this.filtParam(obj, thing))));
  notUniq = (list: any[]) => list.filter((thing, index) => (index !== list.findIndex(obj => this.filtParam(obj, thing))));
  filtParam = (obj: any, thing: any) => JSON.stringify(obj).toLocaleLowerCase() === JSON.stringify(thing).toLocaleLowerCase();

  private separateObject(result: any, dat: any[]) {
    const dData = (result.data as any[]);
    dat.forEach(datRes => Object.keys(dData[dData.length - 1]).forEach(ke => Object.keys(datRes).forEach(datKey => {
      if (ke !== datKey) { delete datRes[datKey]; }
    })));
  }
}
